import { useState } from 'react';
import { styled } from '@mui/system';
import { Button } from '@mui/material';
import ActionDialog from '../ActionDialog';
import { useFollowUserMutation, useUnfollowUserMutation } from '../../../../store/api/userApi';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { DEFAULT_AVATAR } from '../../../../utils/constant';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const FollowStatusContainer = styled('div')({
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  width: '81px',
  justifyContent: 'center',
  '& button': {
    border: 'none',
    fontFamily: 'Fjalla One',
    lineHeight: '20px',
    fontWeight: '400',
  },
});

const Icon = styled('span')({
  color: '#AB9178',
  marginRight: '5px',
});

const FollowBtn = styled(Button)({
  backgroundColor: '#AB9178',
  fontSize: '14px',
  color: '#fff',
  padding: '3px 17px',
  borderRadius: '0',
  '&:hover': {
    color: '#AB9178',
  },
});

const FollowingBtn = styled(Button)({
  fontSize: '16px',
  color: '#AB9178',
  padding: '0',
});

export const LinkToDialog = ({ user }) => {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  const { _id, avatar, userName, followers } = user;
  const [open, setOpen] = useState(false);
  const [followUser] = useFollowUserMutation();
  const [unfollowUser] = useUnfollowUserMutation();
  const currentUserId = useSelector(selectUser);

  // open unfollow popup
  const unFollowClick = () => {
    setOpen(true);
  };

  // close unfollow popup
  const closePopUp = () => {
    setOpen(false);
  };

  const unfollowTheUser = async () => {
    await unfollowUser({ id: _id, userId: currentUserId });
    setOpen(false);
  };

  const followClick = async () => {
    await followUser({ id: _id, userId: currentUserId });
  };

  const followCheck = () => {
    if (_id === currentUserId) {
      return 'yourself';
    }

    return followers.includes(currentUserId) && isLogin ? (
      <>
        <Icon>♦</Icon>
        <FollowingBtn onClick={() => unFollowClick()}>following</FollowingBtn>
      </>
    ) : (
      <FollowBtn onClick={() => followClick()}>follow</FollowBtn>
    );
  };

  return currentUserId && isLogin ? (
    <>
      <FollowStatusContainer>{followCheck()}</FollowStatusContainer>
      <ActionDialog
        img={avatar || DEFAULT_AVATAR}
        name={userName}
        variant="user"
        action="unfollow"
        onClose={closePopUp}
        open={open}
        actionHandler={unfollowTheUser}
        cancelHandler={closePopUp}
      />
    </>
  ) : null;
};
